import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import { AttachmentFieldsFragmentDoc } from '../../../fragments/attachmentFields.generated';
import { AssignedRequirementInfinityFragmentDoc } from '../../VehicleProjects/hooks/AssigedRequirementsInfinity.generated';
import { RequirementFilterOptionsFragmentDoc, AssignedRequirementFilterOptionsFragmentDoc } from '../../../fragments/infinityFilterOptions.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetSearchBaselineQueryVariables = Types.Exact<{
  searchString: Types.Scalars['String'];
}>;


export type GetSearchBaselineQuery = { __typename?: 'Query', searchBaseline?: Array<{ __typename?: 'Baseline', id: string, name: string }> | null };

export type GetBaselinesByModelAndSeriesQueryVariables = Types.Exact<{
  generation: Types.Scalars['String'];
  modelSeries: Types.Scalars['String'];
}>;


export type GetBaselinesByModelAndSeriesQuery = { __typename?: 'Query', vehicleProjectBaselinesByModelAndSeries: Array<{ __typename?: 'Baseline', id: string, name: string, createdAt?: any | null, transferWorkflow: { __typename?: 'TransferWorkflow', transferToCodebeamer: boolean, transferTime?: any | null }, createdBy: { __typename?: 'User', name: string, id: string }, reqIFAttachments: Array<{ __typename?: 'AttachmentRef', attachmentId: string, isVkoOnly?: boolean | null, file: { __typename?: 'BlobRef', uri: any, contentType: string, fileName: string, originalFileName?: string | null }, category?: { __typename?: 'AttachmentCategory', id: string, name: string } | null }> }> };

export type GetBaselineByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type GetBaselineByIdQuery = { __typename?: 'Query', baselineById?: { __typename?: 'Baseline', id: string, name: string, createdAt?: any | null, reqIFAttachments: Array<{ __typename?: 'AttachmentRef', attachmentId: string, isVkoOnly?: boolean | null, file: { __typename?: 'BlobRef', uri: any, contentType: string, fileName: string, originalFileName?: string | null }, category?: { __typename?: 'AttachmentCategory', id: string, name: string } | null }> } | null };

export type GetBaselineByIdWithAssignedReqsQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type GetBaselineByIdWithAssignedReqsQuery = { __typename?: 'Query', baselineById?: { __typename?: 'Baseline', id: string, name: string, createdAt?: any | null, reqIFAttachments: Array<{ __typename?: 'AttachmentRef', attachmentId: string, isVkoOnly?: boolean | null, file: { __typename?: 'BlobRef', uri: any, contentType: string, fileName: string, originalFileName?: string | null }, category?: { __typename?: 'AttachmentCategory', id: string, name: string } | null }>, assignedRequirements: Array<{ __typename?: 'AssignedRequirement', added: any, addedAutomatically: boolean, addReason: string, isProjectRelevant: boolean, projectRelevantComments?: string | null, vehicleProjectsRefs: Array<{ __typename?: 'EntityRefOfVehicleProject', id: string }>, requirement: { __typename?: 'Requirement', dateEffective?: any | null, dateExpiration?: any | null, createdAt?: any | null, id: string, name: string, requirementId?: string | null, status: Types.RequirementStatus, category: Types.RequirementCategory, definition?: string | null, modifiedAt?: any | null, version?: string | null, externalLinks?: Array<string> | null, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, systemLevels: Array<{ __typename?: 'SystemLevel', id: string, name: string }>, markets: Array<{ __typename?: 'Market', id: string, name: string }>, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, successor?: { __typename?: 'Requirement', id: string, name: string } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, regulations?: Array<{ __typename?: 'Regulation', id: string, regulationNumber: string }> | null, regulatoryDocuments?: Array<{ __typename?: 'RegulatoryDocument', id: string, name: string, status: Types.RegulatoryDocumentStatus, workflow: { __typename?: 'Workflow', status: Types.WorkflowStatus } }> | null, attachments?: Array<{ __typename?: 'AttachmentRef', attachmentId: string, isVkoOnly?: boolean | null, file: { __typename?: 'BlobRef', uri: any, contentType: string, fileName: string, originalFileName?: string | null }, category?: { __typename?: 'AttachmentCategory', id: string, name: string } | null }> | null, keywords: Array<{ __typename?: 'Keyword', id: string, name: string, sortPriority?: number | null, descriptions?: Array<{ __typename?: 'TranslationObject', lang: Types.TranslationLang, translation: string }> | null, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, vkos: Array<{ __typename?: 'User', id: string, name: string }> }>, gearboxVariants: Array<{ __typename?: 'GearboxVariant', id: string, name: string }>, bodyworkVariants: Array<{ __typename?: 'BodyworkVariant', id: string, name: string }>, activeTypeMarkets: Array<{ __typename?: 'ActiveTypeMarket', id: string, name: string }>, engineVariants: Array<{ __typename?: 'EngineVariant', id: string, name: string }>, driveVariants: Array<{ __typename?: 'DriveVariant', id: string, name: string }>, vehicleCategories: Array<{ __typename?: 'VehicleCategory', id: string, name: string }>, documentReferences?: Array<{ __typename?: 'DocumentReference', referenceDocumentType?: string | null, reference?: { __typename?: 'Reference', id: string } | null }> | null } }> } | null };

export type GetBaselineRequirementsInfinityQueryVariables = Types.Exact<{
  queryArgsBaselineRequirments: Types.QueryArgsBaselineRequirmentsInput;
}>;


export type GetBaselineRequirementsInfinityQuery = { __typename?: 'Query', baselineRequirementsQuery: { __typename?: 'AssignedRequirementsInfinityResults', requirementIds: Array<string>, requirementFilterOptions: { __typename?: 'RequirementFilterOptions', vexClusterOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }>, categoryOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }>, createdByOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }>, keywordOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }>, marketOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }>, regDocOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }>, regOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }>, statusOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }>, systemLevelOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }>, tagOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }>, requirementOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }>, regDocWorkflowStatusOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }>, requirementIdOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }>, versionOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }> }, assignedRequirementFilterOptions: { __typename?: 'AssignedRequirementFilterOptions', addedAutomaticallyOptions: Array<string>, vehicleProjectOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }> }, assignedRequirementsBatch: Array<{ __typename?: 'AssignedRequirement', added: any, addedAutomatically: boolean, addReason: string, isProjectRelevant: boolean, projectRelevantComments?: string | null, vehicleProjectsRefs: Array<{ __typename?: 'EntityRefOfVehicleProject', id: string }>, requirement: { __typename?: 'Requirement', dateEffective?: any | null, dateExpiration?: any | null, createdAt?: any | null, id: string, name: string, requirementId?: string | null, status: Types.RequirementStatus, category: Types.RequirementCategory, definition?: string | null, modifiedAt?: any | null, version?: string | null, externalLinks?: Array<string> | null, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, systemLevels: Array<{ __typename?: 'SystemLevel', id: string, name: string }>, markets: Array<{ __typename?: 'Market', id: string, name: string }>, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, successor?: { __typename?: 'Requirement', id: string, name: string } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, regulations?: Array<{ __typename?: 'Regulation', id: string, regulationNumber: string }> | null, regulatoryDocuments?: Array<{ __typename?: 'RegulatoryDocument', id: string, name: string, status: Types.RegulatoryDocumentStatus, workflow: { __typename?: 'Workflow', status: Types.WorkflowStatus } }> | null, attachments?: Array<{ __typename?: 'AttachmentRef', attachmentId: string, isVkoOnly?: boolean | null, file: { __typename?: 'BlobRef', uri: any, contentType: string, fileName: string, originalFileName?: string | null }, category?: { __typename?: 'AttachmentCategory', id: string, name: string } | null }> | null, keywords: Array<{ __typename?: 'Keyword', id: string, name: string, sortPriority?: number | null, descriptions?: Array<{ __typename?: 'TranslationObject', lang: Types.TranslationLang, translation: string }> | null, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, vkos: Array<{ __typename?: 'User', id: string, name: string }> }>, gearboxVariants: Array<{ __typename?: 'GearboxVariant', id: string, name: string }>, bodyworkVariants: Array<{ __typename?: 'BodyworkVariant', id: string, name: string }>, activeTypeMarkets: Array<{ __typename?: 'ActiveTypeMarket', id: string, name: string }>, engineVariants: Array<{ __typename?: 'EngineVariant', id: string, name: string }>, driveVariants: Array<{ __typename?: 'DriveVariant', id: string, name: string }>, vehicleCategories: Array<{ __typename?: 'VehicleCategory', id: string, name: string }>, documentReferences?: Array<{ __typename?: 'DocumentReference', referenceDocumentType?: string | null, reference?: { __typename?: 'Reference', id: string } | null }> | null } }> } };

export type GetBaselineRequirementsNextQueryVariables = Types.Exact<{
  nextArgsBaselineRequirments: Types.NextArgsBaselineRequirmentsInput;
}>;


export type GetBaselineRequirementsNextQuery = { __typename?: 'Query', baselineRequirementsNext: Array<{ __typename?: 'AssignedRequirement', added: any, addedAutomatically: boolean, addReason: string, isProjectRelevant: boolean, projectRelevantComments?: string | null, vehicleProjectsRefs: Array<{ __typename?: 'EntityRefOfVehicleProject', id: string }>, requirement: { __typename?: 'Requirement', dateEffective?: any | null, dateExpiration?: any | null, createdAt?: any | null, id: string, name: string, requirementId?: string | null, status: Types.RequirementStatus, category: Types.RequirementCategory, definition?: string | null, modifiedAt?: any | null, version?: string | null, externalLinks?: Array<string> | null, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, systemLevels: Array<{ __typename?: 'SystemLevel', id: string, name: string }>, markets: Array<{ __typename?: 'Market', id: string, name: string }>, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, successor?: { __typename?: 'Requirement', id: string, name: string } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, regulations?: Array<{ __typename?: 'Regulation', id: string, regulationNumber: string }> | null, regulatoryDocuments?: Array<{ __typename?: 'RegulatoryDocument', id: string, name: string, status: Types.RegulatoryDocumentStatus, workflow: { __typename?: 'Workflow', status: Types.WorkflowStatus } }> | null, attachments?: Array<{ __typename?: 'AttachmentRef', attachmentId: string, isVkoOnly?: boolean | null, file: { __typename?: 'BlobRef', uri: any, contentType: string, fileName: string, originalFileName?: string | null }, category?: { __typename?: 'AttachmentCategory', id: string, name: string } | null }> | null, keywords: Array<{ __typename?: 'Keyword', id: string, name: string, sortPriority?: number | null, descriptions?: Array<{ __typename?: 'TranslationObject', lang: Types.TranslationLang, translation: string }> | null, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, vkos: Array<{ __typename?: 'User', id: string, name: string }> }>, gearboxVariants: Array<{ __typename?: 'GearboxVariant', id: string, name: string }>, bodyworkVariants: Array<{ __typename?: 'BodyworkVariant', id: string, name: string }>, activeTypeMarkets: Array<{ __typename?: 'ActiveTypeMarket', id: string, name: string }>, engineVariants: Array<{ __typename?: 'EngineVariant', id: string, name: string }>, driveVariants: Array<{ __typename?: 'DriveVariant', id: string, name: string }>, vehicleCategories: Array<{ __typename?: 'VehicleCategory', id: string, name: string }>, documentReferences?: Array<{ __typename?: 'DocumentReference', referenceDocumentType?: string | null, reference?: { __typename?: 'Reference', id: string } | null }> | null } }> };

export type CreateBaseLineByModelAndSeriesMutationVariables = Types.Exact<{
  input: Types.CreateBaselineInput;
}>;


export type CreateBaseLineByModelAndSeriesMutation = { __typename?: 'Mutation', createBaseLineByModelAndSeries: { __typename?: 'BaselinePayload', baseline: { __typename?: 'Baseline', id: string } } };

export type CreateRequirementsLibraryBaseLineMutationVariables = Types.Exact<{
  input: Types.CreateBaselineRequirementsLibraryInput;
}>;


export type CreateRequirementsLibraryBaseLineMutation = { __typename?: 'Mutation', createRequirementsLibraryBaseLine: { __typename?: 'BaselinePayload', baseline: { __typename?: 'Baseline', id: string } } };

export type UpdateBaselineMutationVariables = Types.Exact<{
  input: Types.UpdateBaselineInput;
}>;


export type UpdateBaselineMutation = { __typename?: 'Mutation', updateBaseline: { __typename?: 'BaselinePayload', baseline: { __typename?: 'Baseline', id: string } } };


export const GetSearchBaselineDocument = gql`
    query GetSearchBaseline($searchString: String!) {
  searchBaseline(searchString: $searchString) {
    id
    name
  }
}
    `;

/**
 * __useGetSearchBaselineQuery__
 *
 * To run a query within a React component, call `useGetSearchBaselineQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchBaselineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchBaselineQuery({
 *   variables: {
 *      searchString: // value for 'searchString'
 *   },
 * });
 */
export function useGetSearchBaselineQuery(baseOptions: Apollo.QueryHookOptions<GetSearchBaselineQuery, GetSearchBaselineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchBaselineQuery, GetSearchBaselineQueryVariables>(GetSearchBaselineDocument, options);
      }
export function useGetSearchBaselineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchBaselineQuery, GetSearchBaselineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchBaselineQuery, GetSearchBaselineQueryVariables>(GetSearchBaselineDocument, options);
        }
export type GetSearchBaselineQueryHookResult = ReturnType<typeof useGetSearchBaselineQuery>;
export type GetSearchBaselineLazyQueryHookResult = ReturnType<typeof useGetSearchBaselineLazyQuery>;
export type GetSearchBaselineQueryResult = Apollo.QueryResult<GetSearchBaselineQuery, GetSearchBaselineQueryVariables>;
export const GetBaselinesByModelAndSeriesDocument = gql`
    query GetBaselinesByModelAndSeries($generation: String!, $modelSeries: String!) {
  vehicleProjectBaselinesByModelAndSeries(
    generation: $generation
    modelSeries: $modelSeries
  ) {
    id
    name
    createdAt
    transferWorkflow {
      transferToCodebeamer
      transferTime
    }
    createdBy {
      name
      id
    }
    reqIFAttachments {
      ...AttachmentFields
    }
  }
}
    ${AttachmentFieldsFragmentDoc}`;

/**
 * __useGetBaselinesByModelAndSeriesQuery__
 *
 * To run a query within a React component, call `useGetBaselinesByModelAndSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBaselinesByModelAndSeriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBaselinesByModelAndSeriesQuery({
 *   variables: {
 *      generation: // value for 'generation'
 *      modelSeries: // value for 'modelSeries'
 *   },
 * });
 */
export function useGetBaselinesByModelAndSeriesQuery(baseOptions: Apollo.QueryHookOptions<GetBaselinesByModelAndSeriesQuery, GetBaselinesByModelAndSeriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBaselinesByModelAndSeriesQuery, GetBaselinesByModelAndSeriesQueryVariables>(GetBaselinesByModelAndSeriesDocument, options);
      }
export function useGetBaselinesByModelAndSeriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBaselinesByModelAndSeriesQuery, GetBaselinesByModelAndSeriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBaselinesByModelAndSeriesQuery, GetBaselinesByModelAndSeriesQueryVariables>(GetBaselinesByModelAndSeriesDocument, options);
        }
export type GetBaselinesByModelAndSeriesQueryHookResult = ReturnType<typeof useGetBaselinesByModelAndSeriesQuery>;
export type GetBaselinesByModelAndSeriesLazyQueryHookResult = ReturnType<typeof useGetBaselinesByModelAndSeriesLazyQuery>;
export type GetBaselinesByModelAndSeriesQueryResult = Apollo.QueryResult<GetBaselinesByModelAndSeriesQuery, GetBaselinesByModelAndSeriesQueryVariables>;
export const GetBaselineByIdDocument = gql`
    query GetBaselineById($id: ID!) {
  baselineById(id: $id) {
    id
    name
    createdAt
    reqIFAttachments {
      ...AttachmentFields
    }
  }
}
    ${AttachmentFieldsFragmentDoc}`;

/**
 * __useGetBaselineByIdQuery__
 *
 * To run a query within a React component, call `useGetBaselineByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBaselineByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBaselineByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBaselineByIdQuery(baseOptions: Apollo.QueryHookOptions<GetBaselineByIdQuery, GetBaselineByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBaselineByIdQuery, GetBaselineByIdQueryVariables>(GetBaselineByIdDocument, options);
      }
export function useGetBaselineByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBaselineByIdQuery, GetBaselineByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBaselineByIdQuery, GetBaselineByIdQueryVariables>(GetBaselineByIdDocument, options);
        }
export type GetBaselineByIdQueryHookResult = ReturnType<typeof useGetBaselineByIdQuery>;
export type GetBaselineByIdLazyQueryHookResult = ReturnType<typeof useGetBaselineByIdLazyQuery>;
export type GetBaselineByIdQueryResult = Apollo.QueryResult<GetBaselineByIdQuery, GetBaselineByIdQueryVariables>;
export const GetBaselineByIdWithAssignedReqsDocument = gql`
    query GetBaselineByIdWithAssignedReqs($id: ID!) {
  baselineById(id: $id) {
    id
    name
    createdAt
    reqIFAttachments {
      ...AttachmentFields
    }
    assignedRequirements {
      ...AssignedRequirementInfinity
    }
  }
}
    ${AttachmentFieldsFragmentDoc}
${AssignedRequirementInfinityFragmentDoc}`;

/**
 * __useGetBaselineByIdWithAssignedReqsQuery__
 *
 * To run a query within a React component, call `useGetBaselineByIdWithAssignedReqsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBaselineByIdWithAssignedReqsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBaselineByIdWithAssignedReqsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBaselineByIdWithAssignedReqsQuery(baseOptions: Apollo.QueryHookOptions<GetBaselineByIdWithAssignedReqsQuery, GetBaselineByIdWithAssignedReqsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBaselineByIdWithAssignedReqsQuery, GetBaselineByIdWithAssignedReqsQueryVariables>(GetBaselineByIdWithAssignedReqsDocument, options);
      }
export function useGetBaselineByIdWithAssignedReqsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBaselineByIdWithAssignedReqsQuery, GetBaselineByIdWithAssignedReqsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBaselineByIdWithAssignedReqsQuery, GetBaselineByIdWithAssignedReqsQueryVariables>(GetBaselineByIdWithAssignedReqsDocument, options);
        }
export type GetBaselineByIdWithAssignedReqsQueryHookResult = ReturnType<typeof useGetBaselineByIdWithAssignedReqsQuery>;
export type GetBaselineByIdWithAssignedReqsLazyQueryHookResult = ReturnType<typeof useGetBaselineByIdWithAssignedReqsLazyQuery>;
export type GetBaselineByIdWithAssignedReqsQueryResult = Apollo.QueryResult<GetBaselineByIdWithAssignedReqsQuery, GetBaselineByIdWithAssignedReqsQueryVariables>;
export const GetBaselineRequirementsInfinityDocument = gql`
    query GetBaselineRequirementsInfinity($queryArgsBaselineRequirments: QueryArgsBaselineRequirmentsInput!) {
  baselineRequirementsQuery(
    queryArgsBaselineRequirments: $queryArgsBaselineRequirments
  ) {
    requirementIds
    requirementFilterOptions {
      ...RequirementFilterOptions
    }
    assignedRequirementFilterOptions {
      ...AssignedRequirementFilterOptions
    }
    assignedRequirementsBatch {
      ...AssignedRequirementInfinity
    }
  }
}
    ${RequirementFilterOptionsFragmentDoc}
${AssignedRequirementFilterOptionsFragmentDoc}
${AssignedRequirementInfinityFragmentDoc}`;

/**
 * __useGetBaselineRequirementsInfinityQuery__
 *
 * To run a query within a React component, call `useGetBaselineRequirementsInfinityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBaselineRequirementsInfinityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBaselineRequirementsInfinityQuery({
 *   variables: {
 *      queryArgsBaselineRequirments: // value for 'queryArgsBaselineRequirments'
 *   },
 * });
 */
export function useGetBaselineRequirementsInfinityQuery(baseOptions: Apollo.QueryHookOptions<GetBaselineRequirementsInfinityQuery, GetBaselineRequirementsInfinityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBaselineRequirementsInfinityQuery, GetBaselineRequirementsInfinityQueryVariables>(GetBaselineRequirementsInfinityDocument, options);
      }
export function useGetBaselineRequirementsInfinityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBaselineRequirementsInfinityQuery, GetBaselineRequirementsInfinityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBaselineRequirementsInfinityQuery, GetBaselineRequirementsInfinityQueryVariables>(GetBaselineRequirementsInfinityDocument, options);
        }
export type GetBaselineRequirementsInfinityQueryHookResult = ReturnType<typeof useGetBaselineRequirementsInfinityQuery>;
export type GetBaselineRequirementsInfinityLazyQueryHookResult = ReturnType<typeof useGetBaselineRequirementsInfinityLazyQuery>;
export type GetBaselineRequirementsInfinityQueryResult = Apollo.QueryResult<GetBaselineRequirementsInfinityQuery, GetBaselineRequirementsInfinityQueryVariables>;
export const GetBaselineRequirementsNextDocument = gql`
    query GetBaselineRequirementsNext($nextArgsBaselineRequirments: NextArgsBaselineRequirmentsInput!) {
  baselineRequirementsNext(
    nextArgsBaselineRequirments: $nextArgsBaselineRequirments
  ) {
    ...AssignedRequirementInfinity
  }
}
    ${AssignedRequirementInfinityFragmentDoc}`;

/**
 * __useGetBaselineRequirementsNextQuery__
 *
 * To run a query within a React component, call `useGetBaselineRequirementsNextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBaselineRequirementsNextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBaselineRequirementsNextQuery({
 *   variables: {
 *      nextArgsBaselineRequirments: // value for 'nextArgsBaselineRequirments'
 *   },
 * });
 */
export function useGetBaselineRequirementsNextQuery(baseOptions: Apollo.QueryHookOptions<GetBaselineRequirementsNextQuery, GetBaselineRequirementsNextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBaselineRequirementsNextQuery, GetBaselineRequirementsNextQueryVariables>(GetBaselineRequirementsNextDocument, options);
      }
export function useGetBaselineRequirementsNextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBaselineRequirementsNextQuery, GetBaselineRequirementsNextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBaselineRequirementsNextQuery, GetBaselineRequirementsNextQueryVariables>(GetBaselineRequirementsNextDocument, options);
        }
export type GetBaselineRequirementsNextQueryHookResult = ReturnType<typeof useGetBaselineRequirementsNextQuery>;
export type GetBaselineRequirementsNextLazyQueryHookResult = ReturnType<typeof useGetBaselineRequirementsNextLazyQuery>;
export type GetBaselineRequirementsNextQueryResult = Apollo.QueryResult<GetBaselineRequirementsNextQuery, GetBaselineRequirementsNextQueryVariables>;
export const CreateBaseLineByModelAndSeriesDocument = gql`
    mutation CreateBaseLineByModelAndSeries($input: CreateBaselineInput!) {
  createBaseLineByModelAndSeries(input: $input) {
    baseline {
      id
    }
  }
}
    `;
export type CreateBaseLineByModelAndSeriesMutationFn = Apollo.MutationFunction<CreateBaseLineByModelAndSeriesMutation, CreateBaseLineByModelAndSeriesMutationVariables>;

/**
 * __useCreateBaseLineByModelAndSeriesMutation__
 *
 * To run a mutation, you first call `useCreateBaseLineByModelAndSeriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBaseLineByModelAndSeriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBaseLineByModelAndSeriesMutation, { data, loading, error }] = useCreateBaseLineByModelAndSeriesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBaseLineByModelAndSeriesMutation(baseOptions?: Apollo.MutationHookOptions<CreateBaseLineByModelAndSeriesMutation, CreateBaseLineByModelAndSeriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBaseLineByModelAndSeriesMutation, CreateBaseLineByModelAndSeriesMutationVariables>(CreateBaseLineByModelAndSeriesDocument, options);
      }
export type CreateBaseLineByModelAndSeriesMutationHookResult = ReturnType<typeof useCreateBaseLineByModelAndSeriesMutation>;
export type CreateBaseLineByModelAndSeriesMutationResult = Apollo.MutationResult<CreateBaseLineByModelAndSeriesMutation>;
export type CreateBaseLineByModelAndSeriesMutationOptions = Apollo.BaseMutationOptions<CreateBaseLineByModelAndSeriesMutation, CreateBaseLineByModelAndSeriesMutationVariables>;
export const CreateRequirementsLibraryBaseLineDocument = gql`
    mutation CreateRequirementsLibraryBaseLine($input: CreateBaselineRequirementsLibraryInput!) {
  createRequirementsLibraryBaseLine(input: $input) {
    baseline {
      id
    }
  }
}
    `;
export type CreateRequirementsLibraryBaseLineMutationFn = Apollo.MutationFunction<CreateRequirementsLibraryBaseLineMutation, CreateRequirementsLibraryBaseLineMutationVariables>;

/**
 * __useCreateRequirementsLibraryBaseLineMutation__
 *
 * To run a mutation, you first call `useCreateRequirementsLibraryBaseLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRequirementsLibraryBaseLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRequirementsLibraryBaseLineMutation, { data, loading, error }] = useCreateRequirementsLibraryBaseLineMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRequirementsLibraryBaseLineMutation(baseOptions?: Apollo.MutationHookOptions<CreateRequirementsLibraryBaseLineMutation, CreateRequirementsLibraryBaseLineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRequirementsLibraryBaseLineMutation, CreateRequirementsLibraryBaseLineMutationVariables>(CreateRequirementsLibraryBaseLineDocument, options);
      }
export type CreateRequirementsLibraryBaseLineMutationHookResult = ReturnType<typeof useCreateRequirementsLibraryBaseLineMutation>;
export type CreateRequirementsLibraryBaseLineMutationResult = Apollo.MutationResult<CreateRequirementsLibraryBaseLineMutation>;
export type CreateRequirementsLibraryBaseLineMutationOptions = Apollo.BaseMutationOptions<CreateRequirementsLibraryBaseLineMutation, CreateRequirementsLibraryBaseLineMutationVariables>;
export const UpdateBaselineDocument = gql`
    mutation UpdateBaseline($input: UpdateBaselineInput!) {
  updateBaseline(input: $input) {
    baseline {
      id
    }
  }
}
    `;
export type UpdateBaselineMutationFn = Apollo.MutationFunction<UpdateBaselineMutation, UpdateBaselineMutationVariables>;

/**
 * __useUpdateBaselineMutation__
 *
 * To run a mutation, you first call `useUpdateBaselineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBaselineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBaselineMutation, { data, loading, error }] = useUpdateBaselineMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBaselineMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBaselineMutation, UpdateBaselineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBaselineMutation, UpdateBaselineMutationVariables>(UpdateBaselineDocument, options);
      }
export type UpdateBaselineMutationHookResult = ReturnType<typeof useUpdateBaselineMutation>;
export type UpdateBaselineMutationResult = Apollo.MutationResult<UpdateBaselineMutation>;
export type UpdateBaselineMutationOptions = Apollo.BaseMutationOptions<UpdateBaselineMutation, UpdateBaselineMutationVariables>;